import useTranslation from '../../localization/i18n.context';
import InfoFeedbackScreen from '../../components/shared/InfoFeedbackScreen/InfoFeedbackScreen';
import WebCard from '../../assets/images/web_card.webp';
import { CloseWebviewEvent } from '../../sdk/close.webview.event';
import useAndroidBackPress from '../../hooks/back.listener.hook';
import { useRef } from 'preact/hooks';

export default function NoCardsPage() {
  const { t } = useTranslation();
  const closeRef = useRef(null);

  useAndroidBackPress(closeRef.current, () => {
    closeRef.current.props.onClick();
  });

  return (
    <InfoFeedbackScreen
      onCloseClick={() => CloseWebviewEvent.closedByUser()}
      closeRef={closeRef}
      image={WebCard}
      title={t('There are no cards to add')}
      subtitle={t("You don't have any card available to add at the moment.")}
      ctaAction={() => CloseWebviewEvent.closedByUser()}
      ctaText={t('Go back')}
    />
  );
}
